/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';
import { Aai20Message } from '../../asyncapi/v2/models/Aai20Message';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { Node } from '../../core/models/Node';

/**
 * A command used to add an OneOf value in operation.
 * 
 * @author vvilerio
 * @extends AbstractCommand
 * @class
 */
export class AddOneOfInMessageCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _newOneOf : any;

    public _oldMessage : any;

    public constructor(message? : any, parentMessage? : any) {
        if(((message != null && message instanceof <any>AaiMessage) || message === null) && ((parentMessage != null && parentMessage instanceof <any>AaiMessage) || parentMessage === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newOneOf===undefined) this._newOneOf = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newOneOf===undefined) this._newOneOf = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
            (() => {
                this._parentPath = Library.createNodePath(parentMessage);
                this._newOneOf = Library.writeNode(message);
            })();
        } else if(message === undefined && parentMessage === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newOneOf===undefined) this._newOneOf = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newOneOf===undefined) this._newOneOf = null;
            if(this._oldMessage===undefined) this._oldMessage = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddOneOfInMessageCommand] Executing.");
        let parent : AaiMessage = <AaiMessage>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        this._oldMessage = Library.writeNode(parent);
        let message : AaiMessage = new Aai20Message(parent, null);
        message.setIsOneOfMessage(true);
        Library.readNode(this._newOneOf, message);
        parent.addOneOfMessage(message, null);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddOneOfInMessageCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldMessage)) {
            return;
        }
        let parentMessage : AaiMessage = <AaiMessage>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parentMessage)) {
            return;
        }
        NodeCompat.setProperty(parentMessage.parent(), "message", parentMessage);
        parentMessage.oneOf = null;
        Library.readNode(this._oldMessage, parentMessage);
    }
}
AddOneOfInMessageCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AddOneOfInMessageCommand";
AddOneOfInMessageCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




